import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  max-height: 100dvh;
  overflow: hidden;
  background-color: ${props => props.theme.colors.white};
  max-width: 400px;
  margin: 0 auto;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background-color: ${props => props.theme.colors.white};
  border-bottom: 1px solid ${props => props.theme.colors.blackShades(0.1)};
  flex-shrink: 0;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: ${props => props.theme.colors.highBlack};
  transition: color 0.2s;

  &:hover {
    color: ${props => props.theme.colors.porterPrimary};
  }
`;

export const HeaderTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${props => props.theme.colors.highBlack};
  margin: 0;
`;

export const Spacer = styled.div`
  width: 40px;
`;

export const ContentArea = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background-color: ${props => props.theme.colors.white};
  border-top: 1px solid ${props => props.theme.colors.blackShades(0.1)};
  flex-shrink: 0;
`;

export const ProgressIndicator = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ProgressDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props =>
    props.$active
      ? props.theme.colors.porterPrimary
      : props.theme.colors.blackShades(0.2)};
  transition: all 0.3s;
`;
